import "../scss/main.scss";

(function ($) {
	$(document).ready(function () {
		theme.init();
	});

	var theme = {
		init: function () {
			this.initSliders();
			this.toggleMenu();
			this.modal();
			this.scrollToAnchor();
			this.fixedNewsletter();
			this.mailchimp();
			this.youtubeVideos();
			this.uploadFileStyle();
			this.changeLogo();
			this.others();
			this.accordion();
			//this.stickyHeader();
			Timeline.init();
		},

		stickyHeader: function () {
			$(window).scroll(function(){
				if ($(window).scrollTop() >= 300) {
					$('header').addClass('fixed-header');
				}
				else {
					$('header').removeClass('fixed-header');
				}
			});
			
		},

		modal: function () {
			$(document).on("click", "[data-open_modal]", function (e) {
				e.preventDefault();
				let id = $(this).data("open_modal");
				var element = document.getElementById(id);
				if (element) {
					var modal = new PlainModal(element);

					if ($(this).data("autoplay_inner_video")) {
						var modalVideo = $(element).find("video");
						if (modalVideo.length > 0) {
							var videoDOMObject = modalVideo[0];
							videoDOMObject.muted = false;
							videoDOMObject.play();
						}
					}

					modal.open();
					modal.closeButton = document.getElementById("close-button");
					var video = $(".video-hero");
					if (video.length > 0) {
						video[0].pause();
					}
				}
			});

			$(document).on("click", "#close-button", function () {
				var video = $(".video-hero");
				if (video.length > 0) {
					video[0].play();
				}
				var video2 = $(this).closest(".modal").find("video");
				if (video2.length > 0) video2[0].pause();
			});
		},

		toggleMenu: function () {
			$(document).on("click", ".toggle-nav", function (e) {
				e.preventDefault();
				$("body").toggleClass("menu-opened");
			});

			$(document).on(
				"click",
				"body.menu-opened header ul.menu li.menu-item-has-children > a",
				function (e) {
					e.preventDefault();
					$(this).parent().find(".sub-menu").slideToggle();
				}
			);

			$(document).on(
				"click",
				"body.menu-opened header ul.menu li.invest .sub-menu li a",
				function () {
					$("body").toggleClass("menu-opened");
				}
			);

			if ($(window).width() > 1080) {
				$(
					"body.page-template-page-invest header .container ul.menu li.projects"
				).mouseover(function () {
					$(this).find("ul.sub-menu").addClass("show");
					$(
						"body.page-template.page-template-page-invest header .container ul.menu li.invest .sub-menu"
					).addClass("hide");
				});

				$(
					"body.page-template-page-invest header .container ul.menu li.projects"
				).mouseout(function () {
					$(this).find("ul.sub-menu").removeClass("show");
					$(
						"body.page-template.page-template-page-invest header .container ul.menu li.invest .sub-menu"
					).removeClass("hide");
				});
			}
		},

		initSliders: function () {
			$(".project-slider").slick({
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 1,
				responsive: [{
						breakpoint: 991,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							infinite: true,
							dots: true,
							arrows: false,
						},
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
							arrows: false,
						},
					},
				],
			});
			if (window.matchMedia("(max-width: 991px)").matches) {
				$(".module-3_boxes .bld-row").slick({
					responsive: [{
							breakpoint: 991,
							settings: {
								slidesToShow: 2,
								speed: 300,
								slidesToScroll: 1,
								infinite: true,
								dots: false,
							},
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 1,
								speed: 300,
								slidesToScroll: 1,
								infinite: true,
								dots: false,
							},
						},
					],
				});
			}
			if (window.matchMedia("(max-width: 767px)").matches) {
				$(".comunnity-blocks").slick({
					responsive: [{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							speed: 300,
							slidesToScroll: 1,
							infinite: true,
							dots: false,
						},
					}, ],
				});
				$(".team-members").slick({
					responsive: [{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							speed: 300,
							slidesToScroll: 1,
							infinite: true,
							dots: false,
						},
					}, ],
				});
			}

			$(".people_section .people_grid.slider").slick({
				dots: false,
				slidesToShow: 5,
				slidesToScroll: 1,
				prevArrow: '<div class="slick-prev slick-arrow">prev</div>',
				nextArrow: '<div class="slick-next slick-arrow">next</div>',
				responsive: [{
						breakpoint: 1200,
						settings: {
							slidesToShow: 4,
						},
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
						},
					},
					{
						breakpoint: 560,
						settings: {
							slidesToShow: 1,
						},
					},
				],
			});

			$("div.content-area main .video-slider").slick({
				prevArrow: '<div class="slick-prev slick-arrow"><b>prev</b><br>video</div>',
				nextArrow: '<div class="slick-next slick-arrow"><b>next</b><br>video</div>',
			});

			$(".carousel").slick({
				slidesToShow: 4,
				slidesToScroll: 4,
				infinite: false,
				prevArrow: '<div class="slick-prev slick-arrow"><b>prev</div>',
				nextArrow: '<div class="slick-next slick-arrow"><b>next</div>',
				responsive: [{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						},
					},
					{
						breakpoint: 800,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 580,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});

			$(".testiminials_slider").slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: '<div class="slick-prev slick-arrow"><b>prev</div>',
				nextArrow: '<div class="slick-next slick-arrow"><b>next</div>',
			});
		},

		scrollToAnchor: function () {
			"use strict";
			$(".scrollTo").on("click", function (e) {
				e.preventDefault();
				var href = $(this).attr("href");
				$("html, body").animate({
						scrollTop: $(href).offset().top,
					},
					1500
				);
			});

			$(".scrollTo a").on("click", function (e) {
				e.preventDefault();
				var href = $(this).attr("href");
				$("html, body").animate({
						scrollTop: $(href).offset().top,
					},
					1500
				);
			});
		},

		fixedNewsletter: function () {
			$(window).scroll(function () {
				if ($(this).scrollTop() > 150) {
					$("#fixed-newsletter").fadeIn();
				} else {
					$("#fixed-newsletter").fadeOut();
				}
			});

			$("#fixed-newsletter .close").click(function () {
				$(this).parent().addClass("hidden");
			});
		},

		mailchimp: function () {
			$("form.mc4wp-form").on("submit", function () {
				$(this).find(".mc4wp-form-fields").delay(1000).fadeOut();
			});
		},

		youtubeVideos: function () {
			$(".video-slider .video .poster").click(function () {
				var video = $(this).parent().find("iframe");
				$(this).fadeOut();
				$(video).contentWindow.postMessage(
					'{"event":"command","func":"' + "playVideo" + '","args":""}',
					"*"
				);
			});
		},

		uploadFileStyle: function () {
			const lang = document.documentElement.lang || 'en-US';
			const langMap = {
				'en-US': 'Add file',
				'es-ES': 'Agregar archivo',
				'pl-PL': 'Dodaj plik',
				'ru-RU': 'Добавить файл'
			};
			$(":file").jfilestyle({
				text: langMap[lang],
				buttonBefore: true,
				inputSize: "100px"
			});
		},

		changeLogo: function () {
			$("body.page-id-431 header .container .logo a.custom-logo-link img").attr(
				"src",
				"https://samana-group.net/wp-content/uploads/2023/02/samana-foundation.svg"
			);
		},

		others: function () {
			$("a#newsletter-btn").click(function (e) {
				e.preventDefault();
				$("#newsletter").slideToggle();
			});

			$("#invest-page .newsletter-home a.close, .page-template-page-contact .newsletter-home a.close").click(function (e) {
				e.preventDefault();
				$("#newsletter").slideToggle();
			});

			$('.floorplans').tabs({ heightStyle: "auto" });
		},

		accordion: function () {
			$(".accordion-item .tab-title").click(function () {
				var tab = $(this).parent().find(".tab-content");

				if (tab.hasClass("opened")) {
					tab.slideUp().removeClass("opened");
				} else {
					$(".accordion-item .tab-content").slideUp().removeClass("opened");
					tab.slideDown().addClass("opened");
				}
			});
		}
	};

	var Timeline = {

		init: function(){

			if($('.timeline').length == 0) return;
			
			this.prepare();
			this.run();
			this.resizeTimeout = null;

			var _this = this;

			$(window).resize(function() {
				clearTimeout(_this.resizeTimeout);
				_this.resizeTimeout = setTimeout(() => {
					_this.prepare();
					_this.run();
				}, 300);			

			});
		},

		prepare: function(){	
			this.desktopSpacerModifier = 1;		
			this.container = $("#timeline");
			this.visibleItemsCount = 4;
			this.calculateItems();
			this.yOffset = 75;
			this.adjustResponsiveParams();		
		},

		calculateItems: function(){
			this.items = this.container.find(".item:visible");
			this.itemWidth = this.items.not('.spacer-left').first().outerWidth();	
			this.itemsToScroll = this.items.length - this.visibleItemsCount + this.desktopSpacerModifier; //+1 for additional spacer (2 * 1.5 width)
		},

		adjustResponsiveParams: function(){
			$('.spacer-left, .spacer-right').show();

			if($(window).width() < 1400){
				this.yOffset = 40;
			}	


			if($(window).width() < 768){
				$('.spacer-left, .spacer-right').hide();
				//all without offset
				this.yOffset = 0;
				this.visibleItemsCount = 1;
				this.itemsToScroll = this.items.length - 1;
				this.desktopSpacerModifier = 0;
				this.calculateItems();
			}	
		},

		run: function(){
			this.createController();
			this.createScene();
			this.relativyItems();
			this.adjustTimelinePadding();
			this.adjustLineAngle();
		},

		adjustLineAngle: function(){
			var width = this.items.length * this.itemWidth;
			var height = (this.items.length) * this.yOffset;						
			var tg = height / width;
			var atan = Math.atan(tg);
			var degrees = atan * 180/Math.PI;
			$('.item_title .line').css({
				transform: `translate(-50%, -50%) rotate(-${degrees}deg)`
			})
		},

		relativyItems: function(){
			var _this = this;
			var counter = 0;
			this.items.each(function(){
				var element = $(this);
				var position = counter++ * _this.yOffset * -1;
				element.css({
					top: position
				})
			});
		},	

		adjustTimelinePadding: function(){
			var paddingTop = (this.visibleItemsCount - 1) * this.yOffset;
			$('.timeline').css({
				'padding-top': paddingTop
			})

			$('.timeline .spacer-left, .timeline .spacer-right').css({
				width: this.itemWidth * 1.5
			})
		},

		createController: function(){

			if(this.controller){
				this.controller.destroy(true);
			}

			this.controller = new ScrollMagic.Controller();
		},

		createScene: function(){	
			
			
			if(this.scene){
				this.scene.destroy(true);
			}

			var _this = this;

			this.scene = new ScrollMagic.Scene({
				triggerElement: this.container[0],
				duration: this.itemWidth * this.items.length,
				triggerHook: "onLeave"
			})
			
			this.scene.setPin(this.container[0]);
			
			this.scene.setTween(TweenLite.to(this.items, 1, {
				x: "-=" + this.itemWidth * this.itemsToScroll,
				y: '+=' + (_this.items.length - _this.visibleItemsCount + _this.desktopSpacerModifier) * _this.yOffset //1 addutional for spacers
			}))

			this.scene.addTo(this.controller);
		}
	}

})(jQuery);